import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import './assets/base.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Dashboard from './pages/dashboard/Dashboard';
import PowerBIDashboard from './pages/dashboard/PowerBIDashboard';
import Report from './pages/dashboard/Report';
import Home from './pages/home/Home';
import Search from './pages/licitations/Search';

function App() {
  return (
    <BrowserRouter>
      <div className="App d-flex flex-column min-vh-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/licitaciones/buscar" element={<Search />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/reporte" element={<Report />} />
          <Route path="/dashboard/powerbi" element={<PowerBIDashboard />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
